const RU = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      visible: true,
      required: true,
    },
    IBAN: {
      visible: false,
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
      placeholder: "bankDetails.swiftMinmaxValidation",
    },
    swiftCoresp: {
      required: true,
      label: "bankDetails.swiftCoresp",
      visible: true,
    },
    accountNumber: {
      required: true,
      visible: true,
      label: "bankDetails.accountNumber",
    },
    controlDigit: {
      label: "bankDetails.controlDigit",
      visible: true,
      required: true,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { RU };
